import { find } from 'lodash';

export function lookupNumberField(object: any, fieldName: string): number {
  let field = find(object.fields, (f:any) => f.name === fieldName);
  
  if(field) {
    return parseInt(field.value, 10) || null;
  }
  else {
    return null;
  }
}